// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tdPW","title":"styles_title__UTZ0K"};